import { getResourceId } from "./getResourceId";

export function getResourcesNodes(svg: SVGSVGElement) {
  const list: SVGGElement[] = [];
  if (!svg) return null;
  const layer = svg.querySelector("g#resources");
  if (!layer) {
    return list;
  }
  const svgPaths: NodeListOf<SVGGElement> = layer.querySelectorAll("g");
  svgPaths.forEach((value: SVGGElement, _: number) => {
    const id = getResourceId(value);
    if (id !== null) {
      list.push(value);
    }
  });
  return list;
}
